import { useTheme } from "next-themes";
import { MagicCard } from "../@/components/magicui/magic-card";
import { useTranslation } from 'react-i18next';
import img1 from '../assets/card1.png';
import img2 from '../assets/card6.png';
import img3 from '../assets/card3.png';
import img4 from '../assets/card5.png';

// Map image imports to their filenames
const imageMap: Record<string, any> = {
  'card1.png': img1,
  'card6.png': img2,
  'card3.png': img3,
  'card5.png': img4
};

export function Card() {
  const { theme } = useTheme();
  const { t } = useTranslation();
  
  // Get translated services with proper typing
  const translations = t('card', { returnObjects: true }) as {
    title: string;
    professions: Array<{
      img: string;
      header: string;
      description: string;
    }>;
  };

  return (
    <section className="w-full flex flex-col items-center justify-center min-h-fit py-24">
      <h1 className="text-2xl md:text-4xl truncate text-amber-300 font-primary font-bold pb-10">
        {translations.title}
      </h1>
      <div className="container sm:mx-2 flex min-h-[350px] flex-col w-full gap-4 lg:h-[350px] lg:flex-row">
        {translations.professions.map((service, index) => (
          <MagicCard
            key={index}
            className="cursor-pointer flex flex-col text-left items-center justify-center shadow-2xl p-4 whitespace-normal text-3xl overflow-hidden rounded-xl bg-white/10 dark:bg-black/10"
            gradientColor={theme === "dark" ? "#262626" : "#D9D9D955"}
          >
            <img 
              src={imageMap[service.img]} 
              className="w-20 h-20 object-cover mb-2" 
              alt={service.header} 
            />
            <h2 className="text-xl truncate text-amber-300 font-secondary font-bold">
              {service.header}
            </h2>
            <h3 className="truncate text-wrap text-[16px]">
              {service.description}
            </h3>
          </MagicCard>
        ))}
      </div>
    </section>
  );
}

export default Card;